import { z } from 'zod'

const validatePhone = () => {
  const schema = z
    .string()
    .regex(
      /^[+]?([0-9]{2})?(\s)*[0-9]{9,15}$/,
      t('zodI18nCustom.invalid_phone'),
    )
  return schema
}

const validatePassword = () => {
  const schema = z
    .string()
    .min(4, t('zodI18nCustom.invalid_password_min', 4))
    .max(32, t('zodI18nCustom.invalid_password_max', 32))

  return schema
}

const validateRequiredCheckbox = () => {
  const schema = z.boolean().refine(value => value === true, {
    message: t('zodI18nCustom.empty_field'),
  })

  return schema
}

export const useZodValidator = () => {
  return {
    validatePhone,
    validatePassword,
    validateRequiredCheckbox,
  }
}
